"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("../messages");
var textOperators = [
    { text: messages_1.columnMenuFilterContainsOperator, operator: 'contains' },
    { text: messages_1.columnMenuFilterNotContainsOperator, operator: 'doesnotcontain' },
    { text: messages_1.columnMenuFilterEqOperator, operator: 'eq' },
    { text: messages_1.columnMenuFilterNotEqOperator, operator: 'neq' },
    { text: messages_1.columnMenuFilterStartsWithOperator, operator: 'startswith' },
    { text: messages_1.columnMenuFilterEndsWithOperator, operator: 'endswith' },
    { text: messages_1.columnMenuFilterIsNullOperator, operator: 'isnull' },
    { text: messages_1.columnMenuFilterIsNotNullOperator, operator: 'isnotnull' },
    { text: messages_1.columnMenuFilterIsEmptyOperator, operator: 'isempty' },
    { text: messages_1.columnMenuFilterIsNotEmptyOperator, operator: 'isnotempty' }
];
var numericOperators = [
    { text: messages_1.columnMenuFilterEqOperator, operator: 'eq' },
    { text: messages_1.columnMenuFilterNotEqOperator, operator: 'neq' },
    { text: messages_1.columnMenuFilterGteOperator, operator: 'gte' },
    { text: messages_1.columnMenuFilterGtOperator, operator: 'gt' },
    { text: messages_1.columnMenuFilterLteOperator, operator: 'lte' },
    { text: messages_1.columnMenuFilterLtOperator, operator: 'lt' },
    { text: messages_1.columnMenuFilterIsNullOperator, operator: 'isnull' },
    { text: messages_1.columnMenuFilterIsNotNullOperator, operator: 'isnotnull' }
];
var dateOperators = [
    { text: messages_1.columnMenuFilterEqOperator, operator: 'eq' },
    { text: messages_1.columnMenuFilterNotEqOperator, operator: 'neq' },
    { text: messages_1.columnMenuFilterAfterOrEqualOperator, operator: 'gte' },
    { text: messages_1.columnMenuFilterAfterOperator, operator: 'gt' },
    { text: messages_1.columnMenuFilterBeforeOperator, operator: 'lt' },
    { text: messages_1.columnMenuFilterBeforeOrEqualOperator, operator: 'lte' },
    { text: messages_1.columnMenuFilterIsNullOperator, operator: 'isnull' },
    { text: messages_1.columnMenuFilterIsNotNullOperator, operator: 'isnotnull' }
];
var booleanOperators = [
    { text: messages_1.columnMenuFilterIsTrue, operator: '' }
];
/**
 * Represents the operators for the ColumnMenuTextFilter, ColumnMenuNumericFilter,
 * ColumnMenuDateFilter and ColumnMenuBooleanFilter components.
 *
 * The text field of each operator object will be resolved according to the
 * [localization messages]({% slug globalization_datatools %}#toc-messages).
 */
var ColumnMenuOperators = /** @class */ (function () {
    function ColumnMenuOperators() {
    }
    Object.defineProperty(ColumnMenuOperators, "text", {
        /**
         * An array containing the operators for the ColumnMenuTextFilter component.
         *
         * The operators are:
         *
         * - { text: 'columnMenu.filterContainsOperator', operator: 'contains' }
         * - { text: 'columnMenu.filterNotContainsOperator', operator: 'doesnotcontain' }
         * - { text: 'columnMenu.filterEqOperator', operator: 'eq' }
         * - { text: 'columnMenu.filterNotEqOperator', operator: 'neq' }
         * - { text: 'columnMenu.filterStartsWithOperator', operator: 'startswith' }
         * - { text: 'columnMenu.filterEndsWithOperator', operator: 'endswith' }
         * - { text: 'columnMenu.filterIsNullOperator', operator: 'isnull' }
         * - { text: 'columnMenu.filterIsNotNullOperator', operator: 'isnotnull' }
         * - { text: 'columnMenu.filterIsEmptyOperator', operator: 'isempty' }
         * - { text: 'columnMenu.filterIsNotEmptyOperator', operator: 'isnotempty' }
         */
        get: function () {
            return textOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnMenuOperators, "numeric", {
        /**
         * An array containing the operators for the ColumnMenuNumericFilter component.
         *
         * The operators are:
         *
         * - { text: 'columnMenu.filterEqOperator', operator: 'eq' }
         * - { text: 'columnMenu.filterNotEqOperator', operator: 'neq' }
         * - { text: 'columnMenu.filterGteOperator', operator: 'gte' }
         * - { text: 'columnMenu.filterGtOperator', operator: 'gt' }
         * - { text: 'columnMenu.filterLteOperator', operator: 'lte' }
         * - { text: 'columnMenu.filterLtOperator', operator: 'lt' }
         * - { text: 'columnMenu.filterIsNullOperator', operator: 'isnull' }
         * - { text: 'columnMenu.filterIsNotNullOperator', operator: 'isnotnull' }
         */
        get: function () {
            return numericOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnMenuOperators, "date", {
        /**
         * An array containing the operators for the ColumnMenuDateFilter component.
         *
         * The operators are:
         *
         * - { text: 'columnMenu.filterEqOperator', operator: 'eq' }
         * - { text: 'columnMenu.filterNotEqOperator', operator: 'neq' }
         * - { text: 'columnMenu.filterAfterOrEqualOperator', operator: 'gte' }
         * - { text: 'columnMenu.filterAfterOperator', operator: 'gt' }
         * - { text: 'columnMenu.filterBeforeOperator', operator: 'lt' }
         * - { text: 'columnMenu.filterBeforeOrEqualOperator', operator: 'lte' }
         * - { text: 'columnMenu.filterIsNullOperator', operator: 'isnull' }
         * - { text: 'columnMenu.filterIsNotNullOperator', operator: 'isnotnull' }
         */
        get: function () {
            return dateOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnMenuOperators, "boolean", {
        /**
         * An array containing the operators for the ColumnMenuBooleanFilter component.
         *
         * The operators are:
         *
         * - { text: 'columnMenu.filterIsTrue', operator: '' }
         */
        get: function () {
            return booleanOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    return ColumnMenuOperators;
}());
exports.ColumnMenuOperators = ColumnMenuOperators;
//# sourceMappingURL=ColumnMenuOperators.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/columnmenu/ColumnMenuOperators.js
// module id = 296
// module chunks = 0